import { Head, usePage } from "@inertiajs/react";
import AuthShell from "@/components/auth/AuthShell";
import CheckEmailCard from "@/components/auth/CheckEmailCard";

export default function CheckEmail({ email, link_expires_in, mail_preview_path }) {
  const { routes } = usePage().props;

  return (
    <AuthShell helpHref={routes.help_parents}>
      <Head title="Check your email" />
      <CheckEmailCard
        description={
          <>
            If that code is right, we've emailed <span className="font-medium text-foreground">{email}</span> a link to
            finish activating. The link works for {link_expires_in}.
          </>
        }
        tips={["Check the code against the take-home sheet (it looks like BEAR-MOON-4217).", "Check your spam folder."]}
        retry={{ href: "/activate", label: "Try a different code" }}
        mailPreviewPath={mail_preview_path}
      />
    </AuthShell>
  );
}
